import { getUnixTime } from 'date-fns';
import { db } from './firebaseConfig';
import { collection, addDoc, updateDoc, doc, deleteDoc, getDoc, getDocs, query, orderBy, where } from 'firebase/firestore';

const addSale = ({ description, amount, date, userId, type, place, payment }) => {
  return addDoc(collection(db, 'sales'), {
    description,
    amount: Number(amount),
    date,
    userId,
    type,
    place,
    payment
  });
}

const getSales = async (begin, end, userId) => {
  if (userId) {
    const queryDB = query(
      collection(db, 'sales'),
      orderBy('date', 'desc'),
      where('date', '>=', getUnixTime(begin)),
      where('date', '<=', getUnixTime(end)),
      where('userId', '==', userId)
    );

    try {
      const snapshot = await getDocs(queryDB);
      const sales = snapshot.docs.map((documento) => {
        return { ...documento.data(), id: documento.id };
      });
      return sales;
    } catch (error) {
      return [];
    }
  } else {
    return [];
  }
}

const getExpenses = async (startDate, endDate, userId) => {
  const expensesRef = collection(db, "expenses");
  const q = query(expensesRef, where("date", ">=", startDate), where("date", "<=", endDate), where("userId", "==", userId));
  const querySnapshot = await getDocs(q);
  const expenses = [];
  querySnapshot.forEach((doc) => {
    expenses.push(doc.data());
  });
  return expenses;
};

const saveConfig = (config) => {
  const docId = config[0].id;
  const docRef = doc(db, 'config', docId);
  return updateDoc(docRef, config[0]);
};

const deleteMonthlyPayment = async (id) => {
  try {
    // Crear una consulta para encontrar el documento con el campo mainPayment igual a mainPaymentId
    const q = query(collection(db, 'payments'), where('mainPayment', '==', id));
    const querySnapshot = await getDocs(q);

    // Iterar sobre los documentos encontrados y eliminarlos
    querySnapshot.forEach(async (doc) => {
      await deleteDoc(doc.ref);
    });

    console.log('Documentos eliminados correctamente');
  } catch (e) {
    console.log('Error al eliminar documentos:', e);
  }
  
  return deleteDoc(doc(db, 'payments', id));
};

const addDetailPayment = async (date, amount, mainPayment) => {
  const docRef = doc(db, 'payments', mainPayment);
  const docSnap = await getDoc(docRef);
  const currentAmount = docSnap.data().pending;
  await updateDoc(docRef, { pending: currentAmount - amount });

  await addDoc(collection(db, 'sales'), {
    amount,
    date,
    description: docSnap.data().desc,
    payment: 'Efectivo',
    place: docSnap.data().place,
    type: docSnap.data().type,
    userId: docSnap.data().userId,
  });

  return addDoc(collection(db, 'payments'), {
    date,
    amount: parseFloat(amount),
    mainPayment: mainPayment
  });
};

const addMonthlyPayment = async (name, date, desc, amount, userId, category,
  place, downpay, paymentType) => {
  try {
    const data = {
      amount: downpay,
      date,
      description: desc,
      payment: paymentType,
      place,
      type: category,
      userId
    };

    // adding the sale entry
    if(downpay !== 0){
      await addDoc(collection(db, 'sales'), data);
    }

    // adding the monthly payment
    const remAmount = amount - downpay;
    const docRef = await addDoc(collection(db, 'payments'), {
      amount,
      date,
      desc,
      name,
      place,
      type: category,
      pending: remAmount,
      userId
    });

    if(downpay !== 0){
      await addDoc(collection(db, 'payments'), { amount: downpay, date, mainPayment: docRef.id });
    }

    return true;
  } catch (error) {
    return false;
  }
}

const addExpense = async (amount, category, date, place, userId) => {
  return await addDoc(collection(db, 'expenses'), {
    amount: parseFloat(amount),
    category,
    date: new Date(date).getTime(),
    place,
    userId: userId
  })
}

const addOrder = async (formData, userId) => {
  try {
    formData.dueDate = Math.floor(new Date(formData.dueDate).getTime() / 1000);
    const order = await addDoc(collection(db, 'orders'), {...formData, userId});
    return order;
  }catch(ex) {
    return null;
  }
}

const updateOrder = async (formData) => {
  const docRef = doc(db, 'orders', formData.id);
  
  delete formData.id;
  formData.dueDate = Math.floor(new Date(formData.dueDate).getTime() / 1000);

  return await updateDoc(docRef, formData);
}

const deleteOrder = async(id) => {
  return deleteDoc(doc(db, 'orders', id));
}


export { addSale, saveConfig, deleteMonthlyPayment, addDetailPayment, addMonthlyPayment, getSales, addExpense, getExpenses, addOrder, deleteOrder, updateOrder };